<div>
  <canvas id="BarChart"></canvas>
  <!-- Il grafico verrà renderizzato qui -->
</div>
